import Categories from 'components/Catalog/Categories/Categories';

export default Categories;
